import type { MaturityEvaluationRubric } from "@/types/maturity";
import {
  getLevelButtonColor,
  MATURITY_LEVEL_LABELS,
} from "@/utils/maturity-colors";

type LevelDescriptionPanelProps = {
  rubric: MaturityEvaluationRubric | undefined;
  level: number;
  showSection?: "doc" | "impl";
};

type RubricSectionProps = {
  heading: string;
  description: string;
};

function RubricSection({ heading, description }: RubricSectionProps) {
  return (
    <div>
      <h4 className="text-xs font-bold text-slate-700 uppercase tracking-wide mb-1">
        {heading}
      </h4>
      <p className="text-xs text-slate-600 leading-relaxed">{description}</p>
    </div>
  );
}

function LevelDescriptionPanel({
  rubric,
  level,
  showSection,
}: LevelDescriptionPanelProps) {
  const { color, bg } = getLevelButtonColor(level);
  const label = MATURITY_LEVEL_LABELS[level] ?? `Nivel ${level}`;

  if (!rubric) return null;

  return (
    <div
      className="rounded-lg p-3 mt-2 space-y-2"
      style={{
        backgroundColor: bg,
        borderLeft: `3px solid ${color}`,
      }}
    >
      <h3 className="text-[10px] font-bold tracking-wide" style={{ color }}>
        NIVEL {level} — {label.toUpperCase()}
      </h3>

      {(!showSection || showSection === "doc") && (
        <RubricSection
          heading="Documentație"
          description={rubric.documentation.description}
        />
      )}

      {(!showSection || showSection === "impl") && (
        <RubricSection
          heading="Implementare"
          description={rubric.implementation.description}
        />
      )}
    </div>
  );
}

export default LevelDescriptionPanel;
